import { render, staticRenderFns } from "./uppy_user_avatar.vue?vue&type=template&id=7a14f432&scoped=true"
import script from "./uppy_user_avatar.vue?vue&type=script&lang=js"
export * from "./uppy_user_avatar.vue?vue&type=script&lang=js"
import style0 from "./uppy_user_avatar.vue?vue&type=style&index=0&id=7a14f432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a14f432",
  null
  
)

export default component.exports